(function () {
  var root = document.querySelector("[data-ff-min]");
  if (!root) return;

  var UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "fbclid"];
  var UTM_STORAGE = "ff_utm_params";
  var FUNNEL_ATTR = "ff_funnel";
  var FUNNEL_VALUE = root.getAttribute("data-ff-funnel") || "planner-minimalist";

  function readStoredUtms() {
    try {
      var parsed = JSON.parse(sessionStorage.getItem(UTM_STORAGE) || "{}");
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function captureUtmParams() {
    var params = new URLSearchParams(window.location.search);
    var stored = readStoredUtms();
    var changed = false;
    UTM_KEYS.forEach(function (key) {
      var value = (params.get(key) || "").trim();
      if (!value) return;
      stored[key] = value.slice(0, 255);
      changed = true;
    });
    if (changed) {
      try {
        sessionStorage.setItem(UTM_STORAGE, JSON.stringify(stored));
      } catch (error) {}
    }
    return stored;
  }

  function utmAttributes() {
    var stored = readStoredUtms();
    var attributes = {};
    UTM_KEYS.forEach(function (key) {
      if (stored[key]) attributes[key] = stored[key];
    });
    return attributes;
  }

  function cartAttributes() {
    var attributes = utmAttributes();
    if (FUNNEL_VALUE) attributes[FUNNEL_ATTR] = FUNNEL_VALUE;
    return attributes;
  }

  function syncAttributeInputs(form, attributes) {
    UTM_KEYS.forEach(function (key) {
      var input = form.querySelector('input[data-ff-min-attr="' + key + '"]');
      if (!attributes[key]) {
        if (input) input.remove();
        return;
      }
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "attributes[" + key + "]";
        input.setAttribute("data-ff-min-attr", key);
        form.appendChild(input);
      }
      input.value = attributes[key];
    });
    if (!FUNNEL_VALUE) return;
    var funnel = form.querySelector('input[data-ff-min-attr="' + FUNNEL_ATTR + '"]');
    if (!funnel) {
      funnel = document.createElement("input");
      funnel.type = "hidden";
      funnel.name = "attributes[" + FUNNEL_ATTR + "]";
      funnel.setAttribute("data-ff-min-attr", FUNNEL_ATTR);
      form.appendChild(funnel);
    }
    funnel.value = FUNNEL_VALUE;
  }

  function cartUpdateUrl() {
    var routes = window.KROWN && KROWN.settings && KROWN.settings.routes;
    var base = (routes && routes.cart_update_url) || "/cart/update";
    return base.indexOf(".js") === base.length - 3 ? base : base + ".js";
  }

  function updateCartAttributes(attributes) {
    if (!Object.keys(attributes).length) return Promise.resolve();
    return fetch(cartUpdateUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {});
  }

  captureUtmParams();

  root.querySelectorAll("form").forEach(function (form) {
    syncAttributeInputs(form, cartAttributes());
    form.addEventListener("submit", function (event) {
      var attributes = cartAttributes();
      syncAttributeInputs(form, attributes);
      if (!Object.keys(attributes).length) return;
      if (form.getAttribute("data-ff-utm-state") === "ready") {
        form.setAttribute("data-ff-utm-state", "idle");
        return;
      }
      if (form.getAttribute("data-ff-utm-state") === "pending") {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      form.setAttribute("data-ff-utm-state", "pending");
      var button = form.querySelector("[type='submit']");
      updateCartAttributes(attributes).finally(function () {
        form.setAttribute("data-ff-utm-state", "ready");
        if (typeof form.requestSubmit === "function") form.requestSubmit(button || undefined);
      });
    }, true);
  });

  // On load, not only on ATC. Same payload as submit so UTMs stay beside ff_funnel.
  updateCartAttributes(cartAttributes());

  var dataNode = root.querySelector("[data-ff-min-variants]");
  var variants = dataNode ? JSON.parse(dataNode.textContent) : [];
  var format = root.getAttribute("data-default-format") || "coil";
  var selected = variants.filter(function (variant) {
    return variant.format === format && variant.available;
  })[0] || variants.filter(function (variant) {
    return variant.available;
  })[0] || variants[0];

  function applyFormat() {
    if (!selected) return;
    root.setAttribute("data-format", selected.format);
    root.querySelectorAll("[data-ff-min-variant]").forEach(function (input) {
      input.value = selected.id;
    });
    root.querySelectorAll("[data-ff-min-option]").forEach(function (button) {
      var on = String(button.getAttribute("data-variant-id")) === String(selected.id);
      button.classList.toggle("is-selected", on);
      button.setAttribute("aria-pressed", on ? "true" : "false");
    });
    root.querySelectorAll("[data-ff-min-cta]").forEach(function (button) {
      var label = button.querySelector(".button__text");
      if (label && !button.dataset.readyHtml) {
        button.dataset.readyHtml = label.innerHTML;
      }
      if (!selected.available) {
        button.disabled = true;
        if (label) label.textContent = button.getAttribute("data-sold-label") || "Sold Out";
      } else {
        button.disabled = false;
        if (label && button.dataset.readyHtml) label.innerHTML = button.dataset.readyHtml;
      }
    });
    root.dispatchEvent(new CustomEvent("ff-min:format"));
  }

  root.addEventListener("click", function (event) {
    var option = event.target.closest("[data-ff-min-option]");
    if (!option || option.disabled) return;
    var next = variants.filter(function (variant) {
      return String(variant.id) === String(option.getAttribute("data-variant-id"));
    })[0];
    if (!next || !next.available) return;
    selected = next;
    applyFormat();
  });

  function initSlider(slider) {
    var slides = JSON.parse(slider.querySelector("[data-ff-min-slides]").textContent);
    var index = 0;
    var image = slider.querySelector("[data-ff-min-main]");
    var thumbs = slider.querySelector("[data-ff-min-thumbs]");
    var dots = slider.querySelector("[data-ff-min-dots]");
    var live = slider.querySelector("[data-ff-min-live]");
    var frame = slider.querySelector("[data-ff-min-frame]");

    function srcFor(slide) {
      return (root.getAttribute("data-format") === "standard") ? slide.standard : slide.coil;
    }

    slides.forEach(function (slide, slideIndex) {
      var thumb = document.createElement("button");
      thumb.type = "button";
      thumb.setAttribute("aria-label", "Show image " + (slideIndex + 1));
      var thumbImg = document.createElement("img");
      thumbImg.alt = "";
      thumb.append(thumbImg);
      thumb.addEventListener("click", function () {
        index = slideIndex;
        render();
      });
      thumbs.append(thumb);

      var dot = document.createElement("button");
      dot.type = "button";
      dot.setAttribute("aria-label", "Show image " + (slideIndex + 1));
      dot.addEventListener("click", function () {
        index = slideIndex;
        render();
      });
      dots.append(dot);
    });

    function render() {
      var slide = slides[index];
      image.src = srcFor(slide);
      image.alt = slide.alt;
      thumbs.querySelectorAll("button").forEach(function (button, buttonIndex) {
        button.classList.toggle("is-active", buttonIndex === index);
        button.querySelector("img").src = srcFor(slides[buttonIndex]);
      });
      dots.querySelectorAll("button").forEach(function (button, buttonIndex) {
        button.classList.toggle("is-active", buttonIndex === index);
        button.setAttribute("aria-current", buttonIndex === index ? "true" : "false");
      });
      slider.querySelector("[data-ff-min-prev]").disabled = index === 0;
      slider.querySelector("[data-ff-min-next]").disabled = index === slides.length - 1;
      if (live) live.textContent = "Showing image " + (index + 1) + " of " + slides.length;
    }

    slider.querySelector("[data-ff-min-prev]").addEventListener("click", function (event) {
      event.stopPropagation();
      index = Math.max(0, index - 1);
      render();
    });
    slider.querySelector("[data-ff-min-next]").addEventListener("click", function (event) {
      event.stopPropagation();
      index = Math.min(slides.length - 1, index + 1);
      render();
    });

    var startX = 0;
    var startY = 0;
    var tracking = false;
    frame.addEventListener("pointerdown", function (event) {
      if (event.target.closest("button")) return;
      tracking = true;
      startX = event.clientX;
      startY = event.clientY;
    });
    frame.addEventListener("pointerup", function (event) {
      if (!tracking) return;
      tracking = false;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      if (Math.abs(dx) < 12 && Math.abs(dy) < 12) {
        openLightbox(image.currentSrc || image.src, image.alt);
        return;
      }
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        index = dx > 0 ? Math.max(0, index - 1) : Math.min(slides.length - 1, index + 1);
        render();
      }
    });

    root.addEventListener("ff-min:format", render);
    render();
  }

  root.querySelectorAll("[data-ff-min-slider]").forEach(initSlider);

  var lightbox = root.querySelector("[data-ff-min-lightbox]");
  var lightboxImg = lightbox ? lightbox.querySelector("img") : null;

  function openLightbox(src, alt) {
    if (!lightbox || !lightboxImg) return;
    lightboxImg.src = src;
    lightboxImg.alt = alt || "";
    lightbox.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  if (lightbox) {
    lightbox.addEventListener("click", function (event) {
      if (event.target === lightbox || event.target.closest("[data-ff-min-lightbox-close]")) closeLightbox();
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeLightbox();
    });
  }

  root.querySelectorAll("[data-ff-min-zoom]").forEach(function (button) {
    button.addEventListener("click", function () {
      var img = button.querySelector("img");
      if (img) openLightbox(img.currentSrc || img.src, img.alt);
    });
  });

  root.querySelectorAll("[data-ff-min-bonus]").forEach(function (item) {
    var trigger = item.querySelector("[data-ff-min-bonus-toggle]");
    trigger.addEventListener("click", function () {
      var open = item.classList.contains("is-open");
      root.querySelectorAll("[data-ff-min-bonus].is-open").forEach(function (other) {
        other.classList.remove("is-open");
        other.querySelector("[data-ff-min-bonus-toggle]").setAttribute("aria-expanded", "false");
      });
      if (!open) {
        item.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
      }
    });
  });

  var more = root.querySelector("[data-ff-min-more]");
  if (more) {
    more.addEventListener("click", function () {
      var open = root.classList.toggle("is-reviews-open");
      more.textContent = open ? "Show Less" : "Show More Reviews";
    });
  }

  var sticky = root.querySelector("[data-ff-min-sticky]");
  if (sticky && window.matchMedia("(max-width: 749px)").matches) {
    var lastY = window.scrollY;
    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      sticky.classList.toggle("is-hidden", y > lastY && y > 100);
      lastY = y;
    }, { passive: true });
  }

  applyFormat();
})();
